/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from 'react';
import classnames from 'classnames';
import { Header } from '@components/header/header';
import { Footer } from '@components/footer/footer';
import Seo from '../seo';
import './layout.scss';

type LayoutType = {
  className?: string;
};

const Layout: React.FC<LayoutType> = ({ children, className }) => (
  <div className="app">
    <Seo />
    <Header />
    <main className={classnames(className || 'main__page')}>{children}</main>
    <Footer />
  </div>
);

export default Layout;
